<!-- Runmode:A3Q,321,TT用のコンポーネント -->
<template>
  <div class="a3q">
    <PinchInActStore/>
    <div class="page-content">
      <div id="eleCorrect" class="correct" v-show="showSpCorrect"></div>
      <div class="inner flexrow" :class="cssLayoutID">

          <div class="toparea-image">
            <div class="eleAni hide">
              <template v-for="(answer, index) in answersList">
                <div v-show="showQestionImage" :id="'Answer' + index" class="img-wrapper" :key="index"
                     @click="clickAnswer(answer, index)"
                     @touchstart="onTouchStart(answer)"
                     @touchend="onTouchEnd()"
                     @touchmove="onTouchEnd()"
                     @mousedown="$emit('hintMouseDown', $event)"
                     @mouseup="$emit('hintMouseUp', $event)"
                     @mousemove="$emit('hintMouseMove', $event)"
                     ondragstart="return false">
                  <img :src="answer.image"/>
                </div>
              </template>
            </div>
            <div v-if="isScrollIconVisible" class="icon-scroll" />
          </div>

          <CommonAct :pathstep="pathstep" :activeType="activeType" :actChoice="false" :horizontalRow="true" :scriptSystems="scriptSystems" :needsSwiper="true"
                     :isShowTextsParent="isShowTextsParent" :isShowVoicesParent="isShowVoicesParent" :isActivesParent="isActivesParent"
                     :isCorrectsParent="isCorrectsParent" :isInCorrectsParent="isInCorrectsParent" :isCompleteParent="isCompleteParent"
                     :changeActives="changeActives" :changeEndAct="changeEndAct" :changeIsCorrects="changeIsCorrects" :changeIsInCorrects="changeIsInCorrects"
                     :changeIsComplete="changeIsComplete" @actPinchIn="recieveActPinchIn"/>
      </div>
    </div>
  </div>
</template>

<script>
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

// コンポーネント
import CommonAct from "./CommonAct";
import PinchInActStore from "./PinchInActStore";

/**
 * img-wrapperの横幅の差
 */
const IMG_WRAPPER_WIDTH_DIFF = 51;

export default {
  name: "A3Q",
  props: {
    pathstep: Object,
    productLanguage: String,
    scriptSystems: Object,
    isScrollIconVisible: Boolean
  },
  mixins: [
    common,
    runmode,
    audio
  ],
  data() {
    return {
      // 出題対象のactData
      currentData: null,
      // 解答用のactの配列
      answersList: [],
      // 正解／不正解を判断するフラグ（storeコミット用）
      ActState: true,
      // 全問正解時のタイマー
      allCorrectTimer: null,
      // 適用するレイアウトクラス
      activeType: "",
      // 出題用のテキスト表示するかを判断するフラグ
      showQestionImage: true,
      // Actのテキスト表示するかを判断するBoolean配列
      isShowTextsParent: [],
      // Actの音声再生アイコンを表示するかを判断するBoolean配列
      isShowVoicesParent: [],
      // 監視用のステータス(EndAct)
      changeEndAct: false,
      // activeクラスを適用するかを判断するBoolean配列
      isActivesParent: [],
      // 監視用のステータス(Active)
      changeActives: false,
      // 正解かを判断するBoolean配列
      isCorrectsParent: [],
      // 監視用のステータス(Correct)
      changeIsCorrects: false,
      // 不正解かを判断するBoolean配列
      isInCorrectsParent: [],
      // 監視用のステータス(InCorrect)
      changeIsInCorrects: false,
      isSelectAnswer: [],
      isCompleteParent: [],
      changeIsComplete: false,
      // スマホ用正解アイコン表示フラグ
      showSpCorrect: false,
      // タッチイベント長押しタイマー
      touchTimer: null,
      tempAnswersList: null,
      // アニメーション中かを判断するオブジェクト（アニメーション中はPromise関数が設定される）
      runningCorrectAnimation: null
    };
  },
  components: {
    CommonAct,
    PinchInActStore
  },
  created: function() {
    this.$store.dispatch("initPinchInAct");
    this.init();
  },
  beforeDestroy: function() {
    var i = 0;
    while (i < this.pathstep.acts.length) {
      this.pathstep.acts[i].correct = false;
      i++;
    }
  },
  methods: {
    /**
     * 初期化処理
     */
    init: function() {
      this.log("A3Q start init");

      // 各Actのテキスト／音声再生アイコン／画像を表示するかを判定する
      this.initShowActText();
      this.initShowActVoice();
      this.initShowActImage();
    },
    /**
     * 問題の出題処理
     */
    question: function() {
      this.log("A3Q start question");

      const self = this;

      this.enabledIconVoice();
      this.deleteAnswerTarget();
      this.deleteAniTarget();
      this.isSelectAnswer = [];
      this.changeIsComplete = false;

      this.currentData = this.getQuestion();

      // スコア表示中・全解答表示中は問題出題しない
      if (this.lessonState == storeConstants.LESSON_STATE_PAUSE || this.dispAllAnswerStatus) {
        return;
      }

      // 問題取得できない場合は、次のpathstepへ遷移する
      if (this.currentData == null) {
        this.changeEndAct = true;

        // 親(Runmode.Vue）に通知する
        this.allCorrectTimer = setTimeout(function() {
          self.$emit("endAct");
        }, constants.ALLCORRECT_INTERVAL);
        return;
      }

      this.isActivesParent = [];
      this.isActivesParent[this.currentData.index] = true;
      this.changeActives = true;

      this.sliderToActiveAct(this.currentData.index).then(function() {
        if (self.isChallenge(self.currentData.act)) {
          // challengeの場合は、解答文テキスト取得し、表示する
          self.setAnswerTarget(self.currentData.index);

          if (self.tempAnswersList == null) {
            self.answersList = self.getAnswers(self.currentData.act.texts[0].basicText);
          } else {
            self.answersList = self.tempAnswersList;
            self.tempAnswersList = null;
          }

          self.$nextTick(function() {
            // 出題アニメーション実行
            self.questionAnimation();
          });
        } else {
          // givenの場合は、問題音声を再生し、次の問題を取得する
          self.audioPlay(self.currentData.act.sounds[0]);
          var endedEvent = function() {
            $(self.myAudio).off("ended error", endedEvent);
            self.changeActives = false;
            self.setInterval(constants.QUESTION_INTERVAL).then(function() {
              self.pathstep.acts[self.currentData.index].correct = true;
              self.question();
            });
          };
          $(self.myAudio).on("ended error", endedEvent);
        }
      });
    },
    /**
     *  解答用テキスト押下処理
     */
    clickAnswer: function(answer, index) {
      this.log("A3Q start clickAnswer");

      const self = this;

      if (this.isSelectAnswer[index]) {
        return;
      }

      this.isSelectAnswer = [];
      this.isSelectAnswer[index] = true;

      // 学習済登録
      this.$emit("updateLearnedGroup");

      for (var Child of this.$children) {
        Child.audioPause();
      }

      this.sliderToActiveAct(this.currentData.index).then(function() {
        if (answer.texts[0].basicText == self.currentData.act.texts[0].basicText) {
          // 正解の場合
          var i = 0;
          while (i < self.answersList.length) {
            self.isSelectAnswer[i] = true;
            i++;
          }

          self.correctAnswer(index);
        } else {
          // 不正解の場合
          self.inCorrectAnswer(index);
        }
      });
    },
    /**
     * 正解時の処理
     */
    correctAnswer: function(index) {
      this.log("A3Q start correctAnswer");

      const self = this;

      this.changeActives = false;
      this.pathstep.acts[this.currentData.index].correct = true;

      // スコアを登録する
      this.setActState(this.ActState);
      this.ActState = true;

      // 正解音の再生
      this.audioCorrect();

      // 正解画像の表示
      this.isCorrectsParent = [];
      this.isInCorrectsParent = [];
      this.isCorrectsParent[this.currentData.index] = true;
      this.changeIsCorrects = true;

      // 正解時アニメーション
      this.setAniTarget(index);
      this.runningCorrectAnimation = this.correctAnimation().then(function() {
        self.setInterval(constants.INCORRECT_INTERVAL).then(function() {
          self.finishedCorrectAnimation();
        });
      });
    },
    /**
     * 不正解時の処理
     */
    inCorrectAnswer: function(index) {
      this.log("A3Q start inCorrectAnswer");

      const self = this;

      this.ActState = false;

      // 不正解音の再生
      this.audioInCorrect();
      // 不正解画像の表示
      this.isCorrectsParent = [];
      this.isInCorrectsParent = [];
      this.isInCorrectsParent[this.currentData.index] = true;
      this.changeIsInCorrects = true;

      this.setInterval(constants.INCORRECT_INTERVAL).then(function() {
        // 不正解画像を非表示に変更する
        self.enabledIconVoice();
        self.changeIsInCorrects = false;
        self.isSelectAnswer[index] = false;
      });
    },
    /**
     * 正解時アニメーション後の処理
     */
    finishedCorrectAnimation: function() {
      this.log("A3Q start finishedCorrectAnimation");

      const self = this;

      this.runningCorrectAnimation = null;
      this.changeIsCorrects = false;

      //clone要素を削除
      $("#cloneAniTarget").remove();
      this.setShowImageAct();

      this.showSpCorrect = false;

      // スコア表示中・全解答表示中は何もしない
      if (this.lessonState == storeConstants.LESSON_STATE_PAUSE || this.dispAllAnswerStatus) {
        return;
      }

      this.audioPlay(this.currentData.act.sounds[0]);
      var endedEvent = function() {
        $(self.myAudio).off("ended error", endedEvent);
        self.setInterval(constants.QUESTION_INTERVAL).then(function() {
          self.question();
        });
      };
      $(self.myAudio).on("ended error", endedEvent);
    },
    /**
     * Runmode毎にActの画像を表示するかを判定する
     */
    setShowImageAct: function() {
      this.log("A3Q start setShowImageAct");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_ThreeTwoOne:
        case constants.RUNMODE_TwoTwo:
          this.isCompleteParent[this.currentData.index] = true;
          this.changeIsComplete = true;
          break;
        case constants.RUNMODE_A3Q:
          break;
        default:
          break;
      }
    },
    /**
     * 出題時アニメーションの移動先に#answerTargetを付与する
     */
    setAnswerTarget: function(index) {
      this.log("A3Q start setAnswerTarget");

      var answerTarget = "#Item" + index + " .item-inner";
      $(answerTarget).attr("id", "answerTarget");
    },
    /**
     * #answerTargetを削除する
     */
    deleteAnswerTarget: function() {
      this.log("A3Q start deleteAnswerTarget");

      var answerTarget = " .item-inner";
      $(answerTarget).removeAttr("id");
    },
    /**
    /* 正解時アニメーションの移動先に#aniTargetを付与する
     */
    setAniTarget: function(index) {
      this.log("A3Q start setAniTarget");

      var aniTarget = "#Answer" + index + " img";
      $(aniTarget).attr("id", "aniTarget");
    },
    /**
     * #aniTargetを削除する
     */
    deleteAniTarget: function() {
      this.log("A3Q start deleteAniTarget");

      var aniTarget = " img";
      $(aniTarget).removeAttr("id");
    },
    /**
    /* 出題時アニメーション
     */
    questionAnimation: function() {
      this.log("A3Q start questionAnimation");

      const self = this;

      this.showQestionImage = true;

      // 移動先の情報を取得
      let eleD = $("#answerTarget");
      let eleS1 = $(".toparea-image .eleAni");

      let offsetTop = eleD.offset().top;
      let offsetLeft = eleD.offset().left;
      let eleWidth = eleD.outerWidth();
      let eleHeight = eleD.outerHeight();

      // 選択肢非表示解除
      eleS1.removeClass("hide");

      // 選択肢の位置を取得
      let offsetTopD;
      if (this.isEnvironmentPc()) {
        offsetTopD = eleS1.offset().top - $(".header").outerHeight();
      } else {
        let topAreaImage = $(".toparea-image");
        offsetTopD = topAreaImage.position().top + parseInt(topAreaImage.css("padding-top"), 10);
      }
      let offsetLeftD = eleS1.offset().left;

      // 選択肢の変更前の横幅
      let tmpElseS1Width = eleS1.width();
      let tmpImgWrapperWidth = eleS1.find(".img-wrapper").width();

      // 選択肢部分のスタイルを移動用に変更
      eleS1.css({
        position: "absolute",
        top: offsetTop,
        left: offsetLeft,
        width: eleWidth,
        height: eleHeight,
        zIndex: 3
      });
      if (this.isEnvironmentPc()) {
        // アニメーション開始 PC
        eleS1.stop().animate({
          top: offsetTopD,
          width: "100%",
          height: "306px",
          left: "0"
        }, 500, function() {
          eleS1.find(".img-wrapper").css("position", "relative");
        });
      } else {
        // img-wrapperの開始時の横幅（%)
        let imgWrapperStartWidth = 100;

        let imgWrapper = eleS1.find(".img-wrapper");
        // 画像配置初期化
        imgWrapper.removeClass("show-image").css({
          width: imgWrapperStartWidth + "%"
        });
        eleS1.stop().animate({
          top: offsetTopD,
          left: offsetLeftD,
          height: "100%",
          width: tmpElseS1Width,
          imgWrapperWidth: IMG_WRAPPER_WIDTH_DIFF
        }, {
          duration: 500,
          queue: false,
          progress: function(animation, percent, remaining) {
            // img-wrapeerのwidthの変化
            // 表示後の画像がACTより小さい場合
            imgWrapper.css({
              width: imgWrapperStartWidth - IMG_WRAPPER_WIDTH_DIFF * percent + "%"
            });
          },
          complete: function() {
            eleS1.css({
              position: "relative",
              top: 0,
              left: 0,
              height: "auto",
              width: ""
            });
            imgWrapper.addClass("show-image");
            // スクロールアイコン表示
            self.$emit("showScrollIcon", document.getElementsByClassName("toparea-image")[0]);
          }
        });
      }
    },
    /**
    /* 正解時アニメーション
    */
    correctAnimation: function() {
      this.log("A3Q start correctAnimation");

      const self = this;
      this.showQestionImage = false;
      let eleS = $("#aniTarget");
      let eleD = $("#answerTarget .aimage img");
      let eleDCard = $("#answerTarget .card");

      // 移動元の情報を取得
      let offsetTopeleS = eleS.offset().top;
      let offsetLefteleS = eleS.offset().left;

      // 移動先の情報を取得
      let offsetTop = eleD.offset().top;
      let offsetLeft = eleD.offset().left;
      let eleWidth = eleD.outerWidth();
      let eleHeight = eleD.outerHeight();

      let headerElem = $(".header");
      let animateTopClone = offsetTopeleS - headerElem.outerHeight();
      let animateTop = offsetTop - headerElem.outerHeight();

      let cardTop = eleDCard.offset().top;
      let cardLeft = eleDCard.offset().left;

      return new Promise(function(resolve, reject) {
        // 移動元の要素をclone
        if (!$("#cloneAniTarget").length) {
          var cloneEleS = $("#aniTarget").clone();
          cloneEleS.attr("id", "cloneAniTarget");
          cloneEleS.prependTo(".page-content");
          cloneEleS.addClass("hide");
          if (self.isEnvironmentPc()) {
            cloneEleS.css({
              top: animateTopClone,
              left: offsetLefteleS,
              position: "absolute",
              zIndex: 99
            });
          } else {
            cloneEleS.css({
              top: 0,
              left: 0,
              position: "absolute",
              zIndex: 99
            });
            // 正解アイコン
            var correct = $("#eleCorrect");
            correct.css({
              top: cardTop,
              left: cardLeft,
              width: eleWidth,
              height: eleHeight
            });
            self.showSpCorrect = true;
          }
        }

        // 移動animate実行
        cloneEleS.stop().animate({
          zIndex: 8,
          top: animateTop,
          left: offsetLeft,
          width: eleWidth,
          height: eleHeight
        }, 500, function() {
          resolve();
        });
      });
    },
    /**
     * 全解答表示時の処理
     */
    showAllAnswer: function() {
      this.log("A3Q start showAllAnswer");

      this.showQestionImage = false;
    },
    /**
     * 全解答解除時の処理
     */
    hideAllAnswer: function() {
      this.log("A3Q start hideAllAnswer");

      this.showQestionImage = true;
    },
    /**
     * 初期表示時に各Actのテキストを表示するかを判定する
     */
    initShowActText: function() {
      this.log("A3Q start initShowActText");

      var i = 0;
      while (i < this.pathstep.acts.length) {
        this.isShowTextsParent[i] = true;
        i++;
      }
    },
    /**
     * 初期表示時に各Actの音声再生アイコンを表示するかを判定する
     */
    initShowActVoice: function() {
      this.log("A3Q start initShowActVoice");

      var i = 0;
      while (i < this.pathstep.acts.length) {
        this.isShowVoicesParent[i] = true;
        i++;
      }
    },
    /**
     * 初期表示時に各ACTの画像を表示するかを判定する
     */
    initShowActImage: function() {
      this.log("A3Q start initShowActImage");

      var i = 0;
      while (i < this.pathstep.acts.length) {
        if (this.isChallenge(this.pathstep.acts[i])) {
          this.isCompleteParent[i] = false;
        } else {
          this.isCompleteParent[i] = true;
        }
        i++;
      }
    },
    /**
     * 長押しイベント開始
     *
     * @param Object act タップしたACT
     */
    onTouchStart: function(act) {
      const self = this;
      this.touchTimer = setTimeout(function() {
        var pinchInActParams = {
          isShowPinchIn: true,
          pinchInAct: act,
          pinchTileText: "",
          pinchInShowAnswerText: "",
          pinchInShowVoice: false,
          pinchInShowTextAct: false,
          pinchInDispText: "",
          pinchInActIndex: 0,
          isCompletes: false,
          horizontalRow: false
        };

        self.$store.dispatch("showPinchIn", pinchInActParams);
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      clearTimeout(this.touchTimer);
    },
    /**
     * Actの拡大表示通知を受け取る
     */
    recieveActPinchIn: function() {
      this.tempAnswersList = this.answersList;
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > div > div > .item:first").clone();
        clones.textArea = clones.card.children("div").children(".item-inner").children(".word");
        clones.textArea.empty();
        clones.textArea.append("<span/>");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first > div > div");
      };

      // 対象テキストを取得
      let targetTexts = this.getAllBasicTexts(this.pathstep.acts, this.productLanguage, this.scriptType, this.scriptSystems.default, false);

      // サイズを確定させる
      this.fixCardAreaSize(targetTexts, cloneCard, clones);
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 適用サイズ取得
      let fixedHeight = this.cardAreaHeight[this.displayMode];
      let fixedFontSize = this.cardAreaFontSize[this.displayMode];
      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner .item > div > .item-inner .word");
      textArea.height(fixedHeight);
      textArea.children("span").css({ fontSize: fixedFontSize });
      // 出題文表示領域の高さを調整する
      let rootHeight = this.getComputedStyleHeight(".root");
      let headerHeight = this.getComputedStyleHeight(".header");
      let footerHeight = this.getComputedStyleHeight(".sp-second-header");
      let cardsContainerHeight = this.getComputedStyleHeight(".cards-container");
      $(".toparea-image").css({
        height: rootHeight - headerHeight - footerHeight - cardsContainerHeight
      });
    }
  },
  mounted: function() {
    if (this.isMobile()) {
      // スマホの場合は、sliderを初期化
      this.sliderInit();
      // 自動調整初期処理
      this.initAutoAdjust([".page-content"], [".page-content"]);
    }

    if (this.lessonState == storeConstants.LESSON_STATE_START) {
      // 問題文の取得
      this.question();
    }
  },
  watch: {
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A3Q watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus) {
        this.showAllAnswer();
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else {
        this.hideAllAnswer();
        this.question();
      }
    },
    /**
     * スコア表示状態を監視する
     */
    lessonState: function(newstatus) {
      this.log("A3Q watch lessonState");

      if (this.lessonState == storeConstants.LESSON_STATE_START) {
        // 問題文の取得
        this.question();
      } else if (this.lessonState == storeConstants.LESSON_STATE_STOP) {
        this.$emit("stopAct");
      } else if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else if (this.lessonState == storeConstants.LESSON_STATE_RESTART) {
        if (!this.dispAllAnswerStatus) {
          this.question();
        }
      }

      // 表示領域自動調整
      let funcs = [this.autoAdjustCardArea, this.applyCardAreaSize];
      this.autoAdjustFirstShown(funcs, [".page-content"]);
    },
    /**
     * 中国語表示切り替え
     *
     * @param string newstatus
     */
    scriptType: function(newstatus) {
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    },
    /**
     * 表示モード切り替え
     *
     * @param string newstatus
     */
    displayMode: function(newstatus) {
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
body.propPc #eleCorrect {
  display: none;
}
body.propSp #eleCorrect {
  position: fixed;
  background-size: 120px 120px;
  z-index: 9;
}
</style>
<style lang="scss">
body.propSp {
  .a3q {
    .card-inner {
      .item .correct {
        display: none !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// A3Q.vue?78c904a1